import { render } from "./identifier-badge.vue?vue&type=template&id=698b3f17&scoped=true"
import script from "./identifier-badge.vue?vue&type=script&lang=js"
export * from "./identifier-badge.vue?vue&type=script&lang=js"

import "./identifier-badge.vue?vue&type=style&index=0&id=698b3f17&lang=scss&scoped=true"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698b3f17"]])

export default __exports__